import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CognitoService } from 'src/app/auth/services/cognito.service';

@Injectable({ providedIn: 'root' })
export class AgentAccessService {
  private hasAccess$ = new BehaviorSubject<boolean>(false);
  private checked = false;

  constructor(private cognito: CognitoService) {}

  /**
   * Verifica si el operador actual es del grupo aguacate_operator.
   * El backend ya valida el email contra AGENT_AUTHORIZED_OPERATORS,
   * aqui solo mostramos el widget a operadores (el backend rechaza si no esta en la lista).
   */
  async checkAccess(): Promise<boolean> {
    if (this.checked) return this.hasAccess$.value;

    try {
      const session = await this.cognito.getSession();
      const groups: string[] =
        session?.accessToken?.payload?.['cognito:groups'] || [];
      this.hasAccess$.next(groups.includes('aguacate_operator'));
    } catch {
      this.hasAccess$.next(false);
    }
    this.checked = true;
    return this.hasAccess$.value;
  }

  resetCache(): void {
    this.checked = false;
  }

  getAccess$(): Observable<boolean> {
    return this.hasAccess$.asObservable();
  }

  get isAuthorized(): boolean {
    return this.hasAccess$.value;
  }
}
